import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useId, useState } from "react";
export const RadioGroupContext = createContext(null);
/**
 * Horizontal group of {@link Radio} controls, spaced 24px apart.
 *
 * Control the selection from the group, or leave each radio to its own `checked` handler.
 *
 * @example
 * <RadioGroup aria-label="Page type" value={pageType} onChange={setPageType}>
 *   <Radio value="live" label="Live" />
 *   <Radio value="hfc" label="Historical" disabled />
 * </RadioGroup>
 */
export const RadioGroup = ({ children, name, value, defaultValue, onChange, ...props }) => {
    const generatedName = useId();
    const isControlled = value !== undefined;
    const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
    const managesSelection = isControlled || defaultValue !== undefined;
    const selected = isControlled ? value : uncontrolledValue;
    const onSelect = (next) => {
        if (!isControlled && managesSelection)
            setUncontrolledValue(next);
        onChange?.(next);
    };
    return (_jsx(RadioGroupContext.Provider, { value: {
            name: name ?? generatedName,
            selected,
            managesSelection,
            onSelect,
        }, children: _jsx("div", { ...props, role: "radiogroup", "data-artis-ui": true, className: "inline-flex flex-row items-center gap-[24px]", children: children }) }));
};
//# sourceMappingURL=RadioGroup.js.map